import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">How to engage someone high in
                                                    idea generation
                                                </div>
                                                <p>People high in idea generation tend to be very creative and
                                                    imaginative. They will drive the
                                                    early theoretical stages of a project and provide constant
                                                    inspiration throughout.</p>
                                                <ul className="greenbullet-list">
                                                    <li>Position this person where they can produce creative
                                                        ideas which will be valued.
                                                    </li>
                                                    <li>Whatever their field, make the most of their ability to
                                                        design. Use these skills at the
                                                        beginning of a project where concepts and project
                                                        outlines are being created.
                                                    </li>
                                                    <li>Ask others to come to them to ‘bounce around’ ideas.
                                                        They’ll love the thrill of helping
                                                        others think things through and the ideas will be of
                                                        better quality as a result.
                                                    </li>
                                                    <li className="textbottompadding">They need to know how
                                                        everything fits together. Take the time to explain how
                                                        decisions
                                                        are arrived at.
                                                    </li>

                                                </ul>

                                            </div>

                                            <div className="uiheading"><p>Use the grid below to help you engage
                                                those around you more effectively and confidently.
                                                Consider how you can:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Observe and talk to team members to identify motivations,
                                                    strengths and development
                                                    needs
                                                </li>
                                                <li>Match team members’ skills and knowledge to the tasks in
                                                    hand to ensure each
                                                    individual has an opportunity to work to his or her
                                                    strengths
                                                </li>
                                                <li>Use the tips given to help you engage the different
                                                    characters in your team.
                                                </li>
                                            </ul>
                                            <div className="subtiltereg"><p><span className="subtiltereg">Use the grid to systematically work through the previous steps:</span>
                                            </p></div>
                                            <table className="ilead_v_sport " border="0" cellPadding="0"
                                                   cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve " align="left" valign="top"
                                                        width="20%">Tasks
                                                    </th>
                                                    <th align="left" valign="top" width="20%">Skills</th>
                                                    <th align="left" valign="top" width="20%">Name</th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="20%">Knowledge Management
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%" style={{height:'400px'}}>

                                                         <textarea className="textareaborder textheght"
                                                                   rows="2"
                                                                   cols="18"
                                                                   style={{height:'98%'}}
                                                                   name="tasks"
                                                                   value={this.props.pageData?.tasks}
                                                                   onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%" style={{height:'400px'}}>

                                                        <textarea className="textareaborder textheght"
                                                                  rows="2"
                                                                  cols="18"
                                                                  style={{height:'98%'}}
                                                                  name="skills"
                                                                  value={this.props.pageData?.skills}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%" style={{height:'400px'}}>

                                                        <textarea className="textareaborder textheght"
                                                                  rows="2"
                                                                  cols="18"
                                                                  style={{height:'98%'}}
                                                                  name="name"
                                                                  value={this.props.pageData?.name}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%" style={{height:'400px'}}>

                                                        <textarea className="textareaborder textheght"
                                                                  rows="2"
                                                                  cols="18"
                                                                  style={{height:'98%'}}
                                                                  name="knowledge"
                                                                  value={this.props.pageData?.knowledge}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}